<template>
    <v-layout row>
        <v-flex xs12>
            <v-card>
                <v-card-title primary-title>
                    <div class="headline">Initiated Jobs List</div>
                </v-card-title>
                <v-container grid-list-xl fluid>
                    <v-layout row wrap justify-space-around>
                        <v-flex xs12 sm6 d-flex>
                            <loading v-if="loading" :loadingMessage="loadingMessage"></loading>
                            <v-list three-line v-else>
                                <template v-if="haveJobs">
                                    <template v-for="(job, index) in descendingJobList">
                                        <v-list-tile :key="job.key" @click="" :to="{name: 'dataops.jobs.read', params: {jobUID: job.key}}">
                                            <v-list-tile-content>
                                                <v-list-tile-title>{{job.inputParams.handler || job.key}}</v-list-tile-title>
                                                <v-list-tile-sub-title>Started by {{job.user.displayName}} at {{formatInitiatedDate(job.initiated)}}</v-list-tile-sub-title>
                                                <v-list-tile-sub-title>Status: {{job.status}}</v-list-tile-sub-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-chip :color="statusColour(job.status)" text-color="white">{{job.status}}</v-chip>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-divider
                                                v-if="index + 1 < descendingJobList.length"
                                                :key="index"
                                        ></v-divider>
                                    </template>
                                </template>
                                <template v-else>
                                    <v-list-tile avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-title>No Jobs</v-list-tile-title>
                                            <v-list-tile-sub-title>No jobs data to show</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                            <router-link :to="{name: 'dataops'}">Import/Export Dashboard</router-link>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
  import _ from 'lodash'
  import {humanDateFromUnix} from '@/utils'

  export default {
    name: 'dataops-JobList',
    data: () => ({
      loading: true,
      loadingMessage: 'Loading jobs...',
      jobList: []
    }),
    created () {
      const self = this
      console.log('Loading Jobs')
      self.$firebaseClient.newRootRef('admin_ops').child('v0').child('jobs').orderByChild('initiated').limitToLast(5).on('value', (snapshot) => {
        self.jobList = []
        snapshot.forEach((childSnapshot) => {
          console.log('Parsing job')
          const job = childSnapshot.val()
          job.key = childSnapshot.key
          self.jobList.push(job)
        })
        self.loading = false
      })
    },
    computed: {
      haveJobs () {
        return this.descendingJobList.length > 0
      },
      descendingJobList () {
        const self = this
        if (!self.jobList) {
          return []
        }
        return _.orderBy(self.jobList, ['initiated'], ['desc'])
      }
    },
    methods: {
      formatInitiatedDate (unixTimestamp) {
        return humanDateFromUnix(unixTimestamp)
      },
      statusColour (status) {
        switch (status) {
          case 'Completed':
            return 'success'
          case 'Aborted':
            return 'error'
          default:
            return 'primary'
        }
      }
    }
  }
</script>

<style scoped>
</style>
